"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


// WEBPACK FOOTER //
// ./~/rxjs/util/isArrayLike.js